<template>
  <div>
    <v-row class="mt-0">
      <v-col cols="12">
        <v-text-field v-model="item.employeeCode" label="Mã NS" outlined hide-details></v-text-field>
      </v-col>
      <v-col cols="12"> 
        <v-textarea v-model="notifBody" label="Nội dung notif hỗ trợ" hide-details="auto" outlined></v-textarea>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="green darken-2" dark style="text-transform: none;" @click="submit"> gởi notif</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>

<script>

import AutoForm from '@/components/CommonView/AutoForm.vue';
import * as moment from "moment/moment";
import { view } from './header'
import { answer } from './api'
export default {
  props: {
    item: {
      type: Object
    },
  },
  components: {
    AutoForm
  },
  computed: {
    fields () {
      return [
        {name: 'id', label:'Id', type: 'text-field', value: this.item?.id, cols: 12 },
        {name: 'employeeCode', label:'Mã nhân viên', type: 'text-field', value: this.item?.employeeCode, cols: 12, md:6 },
        {name: 'employeeName', label:'Tên nhân viên', type: 'text-field', value: this.item?.employeeName, cols: 12, md:6 },
        {name: 'validFrom', label:'Bắt đầu', type: 'text-field', isDate: true, value: this.$formatter.formatDate(this.item?.validFrom, 'YYYY-MM-DD'), cols: 12, md:6 },
        {name: 'validTo', label:'Kết thúc', type: 'text-field', isDate: true, value: this.$formatter.formatDate(this.item?.validTo, 'YYYY-MM-DD'), cols: 12, md:6 },
        {name: 'score', label:'Đánh giá', type: 'text-field', value: `${this.item?.score ?? 0}/${this.item?.maxScore}`, cols: 12, md:6 },
        // {name: 'comments', label:'Bình luận', type: 'text-field', value: this.item?.comments, cols: 12, md:12 },
      ]
    },
    
    viewHeaders () {
      return view([])
    }
  },
  data() {
    return {
      notifBody: "",
      // slots: ['score']
    }
  },
  methods: {
    submit() {
      answer(this.item.employeeCode, this.notifBody)
      return
    },
  }

}
</script>